import { ThreadPrimitive } from '@assistant-ui/react';
import clsx from 'clsx';

import ChatAssistantMessage from './ChatAssistantMessage';
import { useChatContext } from './ChatContext';
import ChatEmptyState from './ChatEmptyState';
import ChatError from './ChatError';
import ChatInput from './ChatInput';
import ChatUserMessage from './ChatUserMessage';

import classes from './chat.module.css';

const ChatMessages = () => {
  const {
    ui: { chatOpen, chatExpanded },
  } = useChatContext();

  const isSidebarMode = chatOpen && !chatExpanded;

  return (
    <ThreadPrimitive.Root className={classes.messagesRoot}>
      <ThreadPrimitive.Viewport className={classes.messagesViewport}>
        <div
          className={clsx(
            classes.messagesContainer,
            isSidebarMode && classes.sidebar,
          )}
        >
          <ThreadPrimitive.Empty>
            <ChatEmptyState />
          </ThreadPrimitive.Empty>
          <ThreadPrimitive.Messages
            components={{
              UserMessage: ChatUserMessage,
              AssistantMessage: ChatAssistantMessage,
            }}
          />
          <ChatError />
        </div>
      </ThreadPrimitive.Viewport>
      <div
        className={clsx(
          classes.messagesInputContainer,
          isSidebarMode && classes.sidebar,
        )}
      >
        <ChatInput />
      </div>
    </ThreadPrimitive.Root>
  );
};

export default ChatMessages;
